import { ActionButtons } from '@/components/molecules';
import { ModalWrapper } from '@/components/organisms';
import { useTeamLeagueInfo } from '@/hooks/custom-hooks/useTeamLeagueInfo';
import { formatTeamLeagueLabels } from '@/utils/helpers';

interface Props {
	handleSubmit: () => void;
	handleCancel: () => void;
	isSubmitDisabled: boolean;
}

export const UnlockMatchupModal = ({ handleSubmit, handleCancel, isSubmitDisabled }: Props) => {
	const teamLeagueInfo = useTeamLeagueInfo();
	const labels = formatTeamLeagueLabels(teamLeagueInfo);

	return (
		<ModalWrapper
			overlayClassName="z-10"
			className="max-w-[400px]"
			title={`Unlock ${labels.matchupSingularTitle}`}
			onClose={() => handleCancel()}
			closeOnOutsideClick
		>
			<p>Are you sure you want to unlock this {labels.matchupSingularTitle}? You will need to complete it once again after your changes.</p>

			<ActionButtons
				className="flex justify-end gap-3 mt-3"
				closeButtonClassName="text-gray-700"
				onClose={handleCancel}
				onSubmit={handleSubmit}
				submitButtonText="Confirm"
				closeButtonText="Cancel"
				submitButtonDisabled={isSubmitDisabled}
			/>
		</ModalWrapper>
	);
};
